import _styled from "styled-components";

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React, { Fragment } from "react";
import PropTypes from "prop-types";
/* 
Basic understanding of the Picture-spec needed to understand this component
https://ericportis.com/posts/2014/srcset-sizes/
https://developer.mozilla.org/en-US/docs/Web/HTML/Element/picture
Notes:
- "types": order is important here, first gets prio by browsers (i.e. put webp before png)
*/
var Picture = function Picture(_ref) {
  var children = _ref.children,
      path = _ref.path,
      alt = _ref.alt,
      fallback = _ref.fallback,
      restProps = _objectWithoutProperties(_ref, ["children", "path", "alt", "fallback"]);

  // add path prop to children
  var childrenWithProps = React.Children.map(children, function (child) {
    return React.cloneElement(child, { path: path });
  });
  return React.createElement(
    "picture",
    null,
    childrenWithProps,
    React.createElement(_StyledImg, _extends({
      src: fallback,
      alt: alt
    }, restProps))
  );
};
export { Picture };
Picture.propTypes = process.env.NODE_ENV !== "production" ? {
  path: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired
} : {};

// type SourceProps = {
//   path?: string;
//   sets: number[];
//   types: string[];
//   platform: string;
//   media?: string;
//   sizes?: string;
// };
var Source = function Source(_ref2) {
  var path = _ref2.path,
      sets = _ref2.sets,
      types = _ref2.types,
      sizes = _ref2.sizes,
      media = _ref2.media,
      platform = _ref2.platform,
      restProps = _objectWithoutProperties(_ref2, ["path", "sets", "types", "sizes", "media", "platform"]);

  var srcSetArray = [];
  types.forEach(function (type) {
    var setArray = [];
    sets.forEach(function (set) {
      setArray.push("" + path + (platform ? "_" + platform : "") + "_" + set + "." + type + " " + set + "w");
    });
    srcSetArray.push({ type: type, setArray: setArray });
  });
  return React.createElement(
    Fragment,
    null,
    srcSetArray.map(function (src, i) {
      return React.createElement("source", _extends({
        key: i,
        srcSet: src.setArray.join(", "),
        sizes: sizes,
        media: media,
        type: "image/" + src.type
      }, restProps));
    })
  );
};
Source.propTypes = process.env.NODE_ENV !== "production" ? {
  sets: PropTypes.array.isRequired,
  types: PropTypes.array.isRequired,
  sizes: PropTypes.string,
  media: PropTypes.string,
  platform: PropTypes.string
} : {};
Picture.Source = Source;

// Example Usages

/* <Picture
  path="/static/homepage/hero_mobile/Anyfin_app"
  fallback="/static/homepage/hero_mobile/Anyfin_app_desktop_500.png"
  alt="Image of Anyfin iPhone and Android App"
  css={`
    width: 100%;
    object-fit: contain;
  `}
>
  <Picture.Source
    sets={[500, 1000, 1500, 2000]}
    types={["webp", "png"]}
    platform={"desktop"}
    media={`(min-width: ${theme.breakpointsRaw[1]}px)`}
    sizes={`calc(50vw - 6rem)`}
  />
  <Picture.Source
    sets={[400, 833]}
    types={["webp", "png"]}
    platform={"mobile"}
    sizes={`calc(100vw - 4rem)`}
  />
</Picture>; */

/*                
  <Picture
    path="/static/homepage/ghost/Anyfin_ghost"
    fallback="/static/homepage/ghost/Anyfin_ghost_250.jpg"
    alt="Image of Anyfin iPhone and Android App"
    css={`
      padding-top: 4vw;
      height: 100%;
      width: 100%;
      object-position: 50% 100%;
      object-fit: contain;
    `}
  >
    <Picture.Source
      sets={[250, 500, 1000, 1500]}
      types={["jpg"]}
      // platform={"desktop"}
      media={`(min-width: ${theme.breakpointsRaw[1]}px)`}
      sizes={`(min-width: ${theme.breakpointsRaw[1]}px) 30vw, 60vw`}
    />
  </Picture>
  */

var _StyledImg = _styled.img.withConfig({
  displayName: "Picture___StyledImg",
  componentId: "sc-1vr8hog-0"
})(["box-sizing:border-box;"]);